<script>
import SectionCard from '../SectionCard.vue';

export default {
  name: 'SalesGallerySection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAnyDetails() {
      const s = this.project.showroom;
      return !!(
        s.address ||
        s.opening_hours_text ||
        s.phone ||
        s.waze_url ||
        s.maps_url
      );
    },
  },
};
</script>

<template>
  <SectionCard section-id="sales" :title="$t('REAL_ESTATE.SALES.TITLE')">
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.SALES.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <p v-if="!hasAnyDetails" class="text-sm text-slate-400">
      {{ $t('REAL_ESTATE.SALES.EMPTY') }}
    </p>
    <dl v-else class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
      <div v-if="project.showroom.address" class="sm:col-span-2">
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.SALES.ADDRESS') }}</dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ project.showroom.address }}
        </dd>
      </div>
      <div>
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.SALES.HOURS') }}</dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ project.showroom.opening_hours_text }}
        </dd>
        <dd class="text-xs text-slate-400 mt-0.5">
          {{ $t('REAL_ESTATE.SALES.HOURS_SOURCE_NOTE') }}
        </dd>
      </div>
      <div>
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.SALES.HOTLINE') }}</dt>
        <dd
          v-if="project.showroom.phone"
          class="text-slate-900 dark:text-slate-100"
        >
          {{ project.showroom.phone }}
        </dd>
        <dd v-else class="text-amber-600 dark:text-amber-400">
          {{ $t('REAL_ESTATE.SALES.HOTLINE_MISSING') }}
        </dd>
      </div>
      <div v-if="project.showroom.waze_url">
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.SALES.WAZE') }}</dt>
        <dd>
          <a
            :href="project.showroom.waze_url"
            target="_blank"
            rel="noopener noreferrer"
            class="text-woot-500 hover:underline"
          >
            {{ $t('REAL_ESTATE.SALES.WAZE_LINK') }}
          </a>
        </dd>
      </div>
      <div v-if="project.showroom.maps_url">
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.SALES.MAPS') }}</dt>
        <dd>
          <a
            :href="project.showroom.maps_url"
            target="_blank"
            rel="noopener noreferrer"
            class="text-woot-500 hover:underline"
          >
            {{ $t('REAL_ESTATE.SALES.MAPS_LINK') }}
          </a>
        </dd>
      </div>
    </dl>
  </SectionCard>
</template>
